import { isDisableInput } from './../../../helpers/property-information.helper';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { District, Region } from 'libs/datalayer/src';
import { Subject } from 'rxjs';
import { FormHelperService } from '../../../helpers/form-helper.service';
import {
    INVALID_STREET_NAME_ERROR_MESSAGE,
    INVALID_STREET_NAME_OR_NUMBER_ERROR_MESSAGE,
    validateNoStreetNameAddedWithNumber,
    validateNoStreetNameOrNumberWithUnitFlat
} from '../../../helpers/address.helper';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';
import { ActivatedRoute } from '@angular/router';
import { isEditOrRelistPage } from '../../../helpers/router.helper';

@Component({
    selector: 'property-information-section',
    templateUrl: './property-information-section.component.html',
    styleUrls: ['./property-information-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertyInformationSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    @ViewChild('propertyInformationSectionForm')
    propertyInformationSectionForm: NgForm;

    selectedRegion: Region;
    selectedDistrict: District;

    hasErrorInStreetNumberAndName = false;
    hasErrorInStreetNumberOrNameAndUnitFlat = false;
    invalidStreetNameErrorMessage = INVALID_STREET_NAME_ERROR_MESSAGE;
    invalidStreetNameOrNumberErrorMessage = INVALID_STREET_NAME_OR_NUMBER_ERROR_MESSAGE;
    isDisableInput: boolean;

    constructor(
        public draftFacade: DraftFacade,
        private route: ActivatedRoute,
        private changeDetectorRef: ChangeDetectorRef,
        protected formHelperService: FormHelperService
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.setIsDisableInput();
            this.updateRegions();
            this.changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        this.hasErrorInStreetNumberAndName = false;
        this.hasErrorInStreetNumberOrNameAndUnitFlat = false;
        this.formHelperService.validate(this.propertyInformationSectionForm);
        const validationResult = this.validate();

        // if page is  a edit page when startDate > 7 then all inputs are disabled => form should be valid
        const isFormDisabled = this.propertyInformationSectionForm.form.disabled;

        return (((isEditOrRelistPage(this.route) && isFormDisabled)
            || this.propertyInformationSectionForm.form.valid)
            && validationResult);
    }

    dirty(): boolean {
        return this.propertyInformationSectionForm.form.dirty;
    }

    private updateRegions() {
        this.selectedRegion = this.metadata.regions.find(
            (region: Region) =>
                region.regionId === this.draftData.propertyInformation.regionId
        );
        this.selectedDistrict = this.selectedRegion?.districts?.find(
            (district: District) =>
                district.districtId ===
                this.draftData.propertyInformation.districtId
        );
    }

    regionChange() {
        this.selectedDistrict = null;
        this.draftData.propertyInformation.districtId = null;
        this.draftData.propertyInformation.suburbId = null;
        this.updateRegions();
        this.publish();
    }

    districtChange() {
        this.draftData.propertyInformation.suburbId = null;
        this.updateRegions();
        this.publish();
    }

    private validate(): boolean {
        if (validateNoStreetNameOrNumberWithUnitFlat(
            this.draftData.propertyInformation.streetName,
            this.draftData.propertyInformation.streetNumber,
            this.draftData.propertyInformation.unitFlat)) {
            this.hasErrorInStreetNumberOrNameAndUnitFlat = true;
            this.changeDetectorRef.markForCheck();
            return false;
        }

        if (
            validateNoStreetNameAddedWithNumber(
                this.draftData.propertyInformation.streetName,
                this.draftData.propertyInformation.streetNumber
            )
        ) {
            this.hasErrorInStreetNumberAndName = true;
            this.changeDetectorRef.markForCheck();
            return false;
        }

        return true;
    }

    private setIsDisableInput(): void {
        this.isDisableInput = isDisableInput(this.route, this.metadata);
    }
}
